import React from "react";
import AdminBlog from "../../components/AdminBlog/AdminBlog";
import Footer from "../../common/Footer/Footer";
import UserPage from "../../common/UserPage/UserPage";

const AdminBlogPage = () => {
  return (
    <div>
      <UserPage />
      <AdminBlog />
      <Footer />
    </div>
  );
};

export default AdminBlogPage;
